<template>
  <!--社区页面-->
  <tk-container disableScroll style="position: relative;">
    <tkui-tab center @change="changeTab($event)" style="height: 1000px;">
      <tkui-tab-item label="全部">
        <posts-container ref="onAllRefreshList" :posts-type="'all'" :profile-id="userInfo.objectId"></posts-container>
      </tkui-tab-item>
      <tkui-tab-item label="关注">
        <posts-container ref="onRefreshList" :posts-type="'watch'" :profile-id="userInfo.objectId"></posts-container>
      </tkui-tab-item>
      <tkui-tab-item label="资讯">
        <posts-container ref="onNewsRefreshList" :posts-type="'news'" :profile-id="userInfo.objectId"></posts-container>
      </tkui-tab-item>
    </tkui-tab>
    <tk-flex
      middle
      center
      v-if="isAuthorizeAccount"
      class="header-right"
      @click.native="$push('/community/postStory')"
    >
      <tk-icon color="#fff" size="16" material>add</tk-icon>
    </tk-flex>
  </tk-container>
</template>

<script>
import postsContainer from '@/components/postsContainer'
export default {
  components: {
    postsContainer
  },
  data () {
    return {
      status: 'loading', // 页面状态
      authorizeAccount: [], // 授权账号数据
      tabNum: 0
    }
  },
  computed: {
    // 判断自己有没有授权发帖
    isAuthorizeAccount () {
      return !!this.authorizeAccount.length
    }
  },
  beforeRouteLeave (to, from, next) {
    next(true)
  },
  activated () {
    this.setStatusBar('dark')
  },
  mounted () {
    this.getInit()
  },
  methods: {
    /**
    * 初始化数据
    * @date: 2020/6/8
    */
    async getInit () {
      try {
        await this.getAuthorizedAccount() // 判断是不是授权发帖账号
      } catch (e) {
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    /**
     * 判断自己有没有授权发帖
     * @date: 2020/3/25
     */
    async getAuthorizedAccount () {
      let authorizeAccount = await this.$tkParse.getList('/classes/authorizeAccount', {
        params: {
          limit: 1,
          where: {
            user: this.userInfo.objectId
          }
        }
      })
      if (authorizeAccount.length) { this.authorizeAccount = authorizeAccount } else { this.authorizeAccount = [] }
    },
    /**
    * 调用子组件方法
    * @date: 2020/6/8
    */
    changeTab (num) {
      if (Number(num) === this.tabNum) { return }
      if (!this.$store.state.footerStatus) {
        this.$store.commit('setFooterStatus', true)
      }
      this.tabNum = Number(num)
      if (this.tabNum === 0) { this.$refs.onAllRefreshList.refreshInitA() }
      if (this.tabNum === 1) { this.$refs.onRefreshList.refreshInitA() }
      if (this.tabNum === 2) { this.$refs.onNewsRefreshList.refreshInitA() }
    }
  }
}
</script>

<style scoped lang="scss">
/*发帖按钮样式*/
.header-right {
  width:24px;
  height:24px;
  position: absolute;top: 13px; right: 15px;
  background:linear-gradient(269deg,rgba(255,150,0,1),rgba(245,112,5,1));
  border-radius: 50%;
}
</style>
